import React, {memo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import Row from "tabloom/build/row"

/** @typedef {object} CardTableRowProps */

/** @typedef {object} CardTableRowState */

/**
 * @extends {ShapeComponent<CardTableRowProps, CardTableRowState>}
 */
class CardTableRow extends ShapeComponent {
  render() {
    return (
      <Row {...this.props} />
    )
  }
}

export default memo(shapeComponent(CardTableRow))
